<template>
  <v-form v-bind="this.$attrs">
    <v-row class="flex-center-between">
      <v-col cols="12" md="5" lg="5">
        <div class="text">Nhóm đối tượng</div>
        <v-tooltip max-width="610px" color="grey darken-1" bottom>
          <template v-slot:activator="{ on, attrs }">
            <p v-bind="attrs" v-on="on" class="nowrap ma-0 text-name">{{ groupInfo.title || '' }}</p>
          </template>
          <span class="white--text tooltip">{{ groupInfo.title || '' }}</span>
        </v-tooltip>
      </v-col>
      <v-col cols="12" md="2" lg="2">
        <div class="text">Phân loại</div>
        <div class="text-name">{{ getCategory() || '' }}</div>
      </v-col>
      <v-col cols="12" md="3" lg="3">
        <div class="text">Số lượng giáo viên</div>
        <div class="text-name">{{ totalStudent }}</div>
      </v-col>
      <v-col cols="12" md="2" lg="2" class="d-flex justify-end align-center">
        <v-btn
          class="v-btn--outlined theme--light v-size--small primary--text font-weight-bold"
          depressed
          @click="$refs['detail-dialog'].openDialog()"
        >
          Hồ sơ chi tiết
        </v-btn>
      </v-col>
    </v-row>

    <InfoDialog ref="detail-dialog" />
  </v-form>
</template>

<script>
import InfoDialog from './InfoDialog.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    InfoDialog
  },
  computed: {
    ...mapGetters({
      groupInfo: 'salaryGroup/groupInfo',
      totalStudent: 'salaryGroupTeacher/countStudents'
    })
  },
  methods: {
    getCategory() {
      switch (this.groupInfo && this.groupInfo.category) {
        case 'default':
          return 'Mặc Định'
        case 'custom':
          return 'Bổ sung'
        default:
          return ''
      }
    }
  }
}
</script>

<style scoped>
.text {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  /* identical to box height, or 143% */
  /* icon, sub */
  color: #797979;
}

.text-name {
  /* H4 */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  /* identical to box height, or 133% */
  color: #000000;
}
.nowrap {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  width: max-content;
  max-width: 100%;
}
.tooltip {
  word-wrap: break-word;
}
</style>
